import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark-gray text-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/d670995f71dfffbfea0ee91022b17116.png" 
              alt="Levent Atalay Logo" 
              className="h-10 w-auto mb-4 md:mb-6 brightness-0 invert"
            />
            <p className="text-gray-400 text-xs md:text-sm leading-relaxed">
              Modern mimari anlayışı, estetik sadelik ve fonksiyonel çözümler üzerine yoğunlaşan mimarlık hizmetleri.
            </p>
          </div>

          <div>
            <h3 className="font-sans text-base md:text-lg font-medium mb-4 md:mb-6">İletişim</h3>
            <ul className="space-y-2 md:space-y-3 text-xs md:text-sm">
              <li>
                <a 
                  href="mailto:info@leventatalay.com.tr" 
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  info@leventatalay.com.tr
                </a>
              </li>
              <li>
                <a 
                  href="tel:+905324498500" 
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  +90 532 449 85 00
                </a>
              </li>
              <li>
                <a 
                  href="https://wa.me/905324498500?text=Merhaba,%20leventatalay.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum." 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  WhatsApp
                </a>
              </li>
            </ul>

            <div className="mt-6">
              <h3 className="font-sans text-base md:text-lg font-medium mb-4">Sosyal Medya</h3>
              <div className="flex items-center gap-4">
                <a
                  href="https://www.instagram.com/loftpiermimarlik/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-600 text-gray-400 hover:text-white hover:border-white transition-colors cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-base"></i>
                </a>
                <a
                  href="https://www.linkedin.com/in/levent-atalay-1ab3503b8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-600 text-gray-400 hover:text-white hover:border-white transition-colors cursor-pointer"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-line text-base"></i>
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-sans text-base md:text-lg font-medium mb-4 md:mb-6">Hızlı Bağlantılar</h3>
            <ul className="space-y-2 md:space-y-3 text-xs md:text-sm">
              <li>
                <Link 
                  to="/" 
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link 
                  to="/hakkinda" 
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Hakkında
                </Link>
              </li>
              <li>
                <Link 
                  to="/mimari-yaklasim" 
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Mimari Yaklaşım
                </Link>
              </li>
              <li>
                <Link 
                  to="/projeler" 
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Seçili Projeler
                </Link>
              </li>
              <li>
                <Link 
                  to="/blog" 
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link 
                  to="/iletisim" 
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                >
                  İletişim
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center text-sm text-gray-400">
          <p>&copy; 2025 Levent Atalay. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
